import React, { createContext } from 'react';
import { UseFloatingReturn } from '@floating-ui/react-dom';

interface SelectContextProps {
  value: string;
  onChange: (value: string, label?: string) => void; // The label is only sent back if you pass options and there is a matching value record
  isOpen: boolean;
  setIsOpen: React.Dispatch<React.SetStateAction<boolean>>;
  refs: UseFloatingReturn['refs'];
  x: number | null;
  y: number | null;
  strategy: React.CSSProperties['position'];
  optionsMap?: Record<string, string>; // Maps "value" (key) to "label" (value)
}

export const SelectContext = createContext<SelectContextProps | undefined>(
  undefined,
);

export const useSelectContext = () => {
  const context = React.useContext(SelectContext);
  if (!context) {
    throw new Error('Select components must be used within a Select provider');
  }
  return context;
};
